<template>
  <div class="time-band-cards">
    <!-- 発地の時間帯区分 -->
    <YhcServiceLevelTimeSlot
      title="お預かり時"
      :time-band-code="fromTimeBandCode"
      :just-on-time-option="fromJustOnTimeOption"
      :just-on-time-option-notice="fromJustOnTimeOptionNotice"
      :is-user-view="isUserView"
      :is-corporation-view="isCorporationView"
      :revision-note="fromRevisionNote"
      :span-note="fromSpanNote"
      :span-period-label="fromSpanPeriodLabel"
    >
      <template
        v-if="fromSpanNote"
        #spanPreview
      >
        <YhcServiceLevelTimeSlot
          hide-header
          :time-band-code="fromSpanTooltipCode || '3'"
          :is-user-view="isUserView"
          :is-corporation-view="isCorporationView"
        />
      </template>
    </YhcServiceLevelTimeSlot>

    <!-- 着地の時間帯区分 -->
    <YhcServiceLevelTimeSlot
      title="お届け時"
      :time-band-code="toTimeBandCode"
      :just-on-time-option="toJustOnTimeOption"
      :just-on-time-option-notice="toJustOnTimeOptionNotice"
      :is-user-view="isUserView"
      :is-corporation-view="isCorporationView"
      :revision-note="toRevisionNote"
      :span-note="toSpanNote"
      :span-period-label="toSpanPeriodLabel"
    >
      <template
        v-if="toSpanNote"
        #spanPreview
      >
        <YhcServiceLevelTimeSlot
          hide-header
          :time-band-code="toSpanTooltipCode || '3'"
          :is-user-view="isUserView"
          :is-corporation-view="isCorporationView"
        />
      </template>
    </YhcServiceLevelTimeSlot>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { ModelYhcOptions } from '../../../../models/fireModels/yhcDataTypes'
import YhcServiceLevelTimeSlot from './YhcServiceLevelTimeSlot.vue'

export default defineComponent({
  name: 'YhcServiceLevelTimeBand',
  components: {
    YhcServiceLevelTimeSlot,
  },
  props: {
    fromTimeBandCode: {
      type: String,
      required: true,
    },
    toTimeBandCode: {
      type: String,
      required: true,
    },
    fromJustOnTimeOption: {
      type: Object as PropType<ModelYhcOptions | null>,
      default: null,
    },
    toJustOnTimeOption: {
      type: Object as PropType<ModelYhcOptions | null>,
      default: null,
    },
    fromJustOnTimeOptionNotice: {
      type: String,
      default: '',
    },
    toJustOnTimeOptionNotice: {
      type: String,
      default: '',
    },
    isUserView: {
      type: Boolean,
      default: false,
    },
    isCorporationView: {
      type: Boolean,
      default: false,
    },
    fromRevisionNote: {
      type: String,
      default: '',
    },
    toRevisionNote: {
      type: String,
      default: '',
    },
    fromSpanNote: {
      type: String,
      default: '',
    },
    toSpanNote: {
      type: String,
      default: '',
    },
    fromSpanPeriodLabel: {
      type: String,
      default: '',
    },
    toSpanPeriodLabel: {
      type: String,
      default: '',
    },
    fromSpanTooltipCode: {
      type: String,
      default: '',
    },
    toSpanTooltipCode: {
      type: String,
      default: '',
    },
  },
})
</script>

<style>
/* 時間帯区分カードのスタイル */
.time-band-cards {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  margin-top: 0.5rem;
}
</style>
